
import { createStore, compose, applyMiddleware } from 'redux';
import { createMigrate, persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import multi from 'redux-multi';
import { routerMiddleware } from 'react-router-redux';
import rootReducer from '../reducers/rootReducer';
import migrations from './migrations/migrations';

export const createPersistConfig = (storage) => ({
  key: 'root',
  version: 2,
  storage,
  blacklist: ['routing', 'auth.axios'],
  migrate: createMigrate(migrations, { debug: false })
});

const configureStore = (preloadedState, storage) => {
	let store = createStore(
	  persistReducer(createPersistConfig(storage), rootReducer),
	  preloadedState,
	  compose(
	  	applyMiddleware(multi, thunk),
	  )
	)
  let persistor = persistStore(store)
  return { store, persistor };
};

export default configureStore;